module.exports = __webpack_public_path__ + "img/5.b5ba46f7.svg";